import { useMemo } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { UserRole } from '../models/enums';

export const useAuth = () => {
  const ctx = useAuthContext();
  const helpers = useMemo(() => ({
    isAdmin: ctx.role === UserRole.Admin,
    isManager: ctx.role === UserRole.Manager || ctx.role === UserRole.Admin,
    isCommercial: ctx.role === UserRole.Commercial || ctx.role === UserRole.Manager || ctx.role === UserRole.Admin,
  }), [ctx.role]);
  return { ...ctx, ...helpers };
};
